import { UIAction, UIActionType } from '../../actions/uiActions';
import { WorkspaceKeyPermission } from '~/types/WorkspaceKeyTypes';

type WorkspaceKeyState = {
  dialogOpen: boolean;
  keyId: string;
  prefilledFlags?: WorkspaceKeyPermission[];
};

export const wsKeyDialogState = (state = {} as WorkspaceKeyState, action: UIAction) => {
  switch (action.type) {
    case UIActionType.TOGGLE_WS_KEY_DIALOG:
      return {
        dialogOpen: !state.dialogOpen,
        keyId: action.keyId,
        prefilledFlags: action.flags,
      } as WorkspaceKeyState;
    default:
      return state;
  }
};

export default wsKeyDialogState;
